import { render, staticRenderFns } from "./crm-home.vue?vue&type=template&id=7d1e8b46&"
import script from "./crm-home.vue?vue&type=script&lang=js&"
export * from "./crm-home.vue?vue&type=script&lang=js&"
import style0 from "./crm-home.vue?vue&type=style&index=0&id=7d1e8b46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports